import { useState, useEffect } from 'react';

/**
 * 내일 동일한 시간까지 남은 시간을 계산하는 훅
 * @param lastRewardedAt 마지막 보상 받은 시간 (ISO8601 문자열)
 * @returns 남은 시간을 "HH:MM:SS" 형식으로 반환, null이면 null 반환
 */
export const useCountdownToNextDay = (lastRewardedAt: string | null | undefined): string | null => {
  const [countdown, setCountdown] = useState<string | null>(null);

  useEffect(() => {
    if (!lastRewardedAt) {
      setCountdown(null);
      return;
    }

    const updateCountdown = () => {
      const lastRewarded = new Date(lastRewardedAt);
      const now = new Date();

      // 내일 같은 시간 계산
      const nextReward = new Date(lastRewarded);
      nextReward.setDate(nextReward.getDate() + 1);

      const diff = nextReward.getTime() - now.getTime();

      if (diff <= 0) {
        // 이미 지났으면 null 반환 (보상 가능 상태)
        setCountdown(null);
        return;
      }

      // 시간, 분, 초 계산
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setCountdown(
        `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      );
    };

    // 즉시 한 번 실행
    updateCountdown();

    // 1초마다 업데이트
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [lastRewardedAt]);

  return countdown;
};
